export default __webpack_public_path__ + "static/happy-robot-565eb15a472c47512be10abb292c5976.svg";